var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropzone',{ref:"postFilesDropzone",attrs:{"id":"postFilesDropzone","options":_vm.options},on:{"vdropzone-success":_vm.uploaded,"vdropzone-sending":_vm.sending,"vdropzone-removed-file":_vm.removed}})}
var staticRenderFns = []

export { render, staticRenderFns }